export const call = (fn, ...inputs) => fn(...inputs)
